import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal, TextField, Tooltip } from "@mui/material";
//*files
import cssClasses from "./UpdateLeadDetails.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";

import { useSelector } from "react-redux";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import CryptoJS from "crypto-js";

import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
//service
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { Network } from "@capacitor/network";

import MobileStepper from "@mui/material/MobileStepper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { checkLeadEmailExists, checkLeadEmailExistsInCp, checkLeadEmailExistsInUsers, checkPhoneNumberIsBlackListed, updateLeadLoginTable, updateLeadPersonTable } from "../../Services/Lead";
import { useRef } from "react";
import { debounce } from "lodash";
import { sendOTPMessage, sendOTPMessageMail } from "../../Services/SmsService";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { createVirtualAccount } from "../../Services/PaymentApi";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));
const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused": {
            background: "#FFFFFF",
            border: "1px solid #84CAFF !important",
            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
export default function UpdateLeadDetails({ open, handleClose, returnRes, data }) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [totalSteps, setTotalStep] = useState(3);
  const [activeStep, setActiveStep] = useState(1);
  const classes = useStyles();
  // ** Update Lead Email and Phone Number
  const [emailLabelText, setEmailLabelText] = useState("");
  const [updateProfile, setUpdateProfile] = useState({
    email: '',
    contactNumber: ''
  });
  const [helperText, setHelperText] = useState({
    email: "",
    isPhoneNumber: "",
    disableEmail: false,
    disableContactNumber: false,
    onChangePhoneNumber: false,
    onChangeEmail: false
  });
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  // const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const verifiedPhoneNumber = useRef(false);
  // const [verifiedEmail, setVerifiedEmail] = useState(false);
  const verifiedEmail = useRef(false);
  const [otptimerEmail, setOtpTimerEmail] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [emailState, setEmailState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
  // ------------------------Phone number otp
  const [showOtp, setShowOtp] = useState(false);
  const [isInterNational, setIsInterNational] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [otptimer, setOtpTimer] = useState(false);
  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [recievedOtp, setRecievedOtp] = useState(null);
  function closeModal() {
    handleClose();
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    console.log({ data });
    setUpdateProfile((pre) => {
      pre.email = data?.leademail;
      pre.contactNumber = data?.leadcontactnumber;
      return { ...pre }
    });
  }, [])

  //   --------------------------------------------------------------------------
  // !!Otp
  const checkEmailExists = useRef(debounce(async (e) => {
    console.log({ e });
    let emailExists = null;
    if (e === updateProfile?.email) {
      setHelperText((pre) => {
        pre.onChangeEmail = false;
        pre.email = '';
        return { ...pre }
      });
    } else {
      setHelperText((pre) => {
        pre.onChangeEmail = true;
        return { ...pre }
      });

      // ??First checked in leads 
      await checkLeadEmailExists(e).then((emailCheckResp) => {
        console.log({ emailCheckResp });

        if (emailCheckResp.length > 0) {
          emailExists = true;
          console.log({ emailExists });
        } else {
          console.log({ emailExists });
          emailExists = false;
          setHelperText((pre) => {
            pre.email = '';
            return { ...pre }
          });

        }
      }).catch((error) => {
        console.log(error);
      });
      // ??Second Check in Users
      if (!emailExists) {
        await checkLeadEmailExistsInUsers(e).then((responseInUser) => {
          if (responseInUser.length > 0) {
            emailExists = true;
            console.log({ emailExists });
          } else {
            emailExists = false;
            console.log({ emailExists });
          }
        }).catch((err) => {
          console.log(err.message);
        });
      }
      // ??Third Check in Cp
      if (!emailExists) {
        await checkLeadEmailExistsInCp(e).then((cpRespEmail) => {
          if (cpRespEmail.length > 0) {
            emailExists = true;
          } else {
            emailExists = false;
          }
          console.log({ emailExists });

        });
      }
      if (emailExists) {
        console.log({ emailExists });
        setHelperText((pre) => {
          pre.email = 'Email Already exists';
          return { ...pre }
        });
        setEmailLabelText('');
      } else {
        setHelperText((pre) => {
          pre.email = '';
          return { ...pre }
        });
        setEmailLabelText('Send Otp');

      }
    }
  }, 900)).current;
  function sendOtpToVerifyEmail() {
    setHelperText((pre) => {
      pre.email = "";
      return { ...pre };
    });
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailLabelText('');
    let body = {
      email: updateProfile.email
    };
    sendOTPMessageMail(body).then((resp) => {
      if (resp.data.success) {
        var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
        var originalText = bytes.toString(CryptoJS.enc.Utf8);
        console.log("Email Registration OTP", parseInt(originalText));
        setRecievedEmailOtp(parseInt(originalText));
        // 900000 ;15 min
        const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
      } else {
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost("Something went wrong");
        }
      }
    });
  }
  function smsTimeOutForEmailVerify() {
    if (verifiedEmail === false) {
      setHelperText((pre) => {
        pre.email = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setEmailLabelText('Resend Otp');
      setOtpTimerEmail(false);
      // setVerifiedEmail(false);
      verifiedEmail.current = false;

    } else {
      setShowEmailOtp(true);
      setOtpTimerEmail(true);
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedEmailOtp(null);
    }
  }
  // !!Email otp
  function optEmailChange(value1, event) {
    event.preventDefault();
    setEmailState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split('-')[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling)
          elmnt.target.nextSibling.focus();
      }
    }
  };
  // !!For Email
  function submitEmailOtp() {
    let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
    console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
    if (finalValue == recievedEmailOtp) {
      // setVerifiedEmail(true);
      verifiedEmail.current = true;
      setShowEmailOtp(false);
      setOtpTimerEmail(false);
      setEmailLabelText('');
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
    } else {
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  // -------------------------------------------------------------------------------
  const IsNumberBlackListed = useRef(debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        verifiedPhoneNumber.current = false;
        // setVerifiedPhoneNumber(false);
        if (resp.length > 0) {
          setHelperText((pre) => {
            pre.isPhoneNumber = "This number is already in use!";
            // pre.isPhoneNumber = "This number has been blacklisted";
            return { ...pre };
          });
        } else {
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            pre.onChangePhoneNumber = true;
            return { ...pre };
          });
          // setVerifiedPhoneNumber(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800)).current;




  // function smsApiCall() {
  //   setResendButton(false);
  //   // const myTimeout = setTimeout(() => {
  //   //   setResendButton(true);
  //   // }, 180000);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   setShowOtp(true);
  //   let body = {
  //     number: updateProfile.contactNumber,
  //     isInterNational: isInterNational,
  //   };
  //   console.log(body);

  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       console.log("enter in smsotp");
        
  //       if (resp.data.success) {
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         console.log("Updated OTP", parseInt(originalText));
  //         setRecievedOtp(parseInt(originalText));
  //         // 900000 ;15 min
  //         const myTimeout = setTimeout(smsTimeOut, 900000);
  //       } else {
  //         if (resp?.data?.error?.ErrorMessage) {
  //           errorTost(resp?.data?.error?.ErrorMessage);
  //         } else {
  //           errorTost("Something went wrong");
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       console.log(err.message);
  //     });
  // }

function smsApiCall() {
  setResendButton(false);

  // Clear OTP inputs
  setState((pre) => {
    return { ...pre, otp1: "", otp2: "", otp3: "", otp4: "" };
  });

  setShowOtp(true);

  let body = {
    number: updateProfile.contactNumber,
    isInterNational: isInterNational,
    email: updateProfile.email ?? null,
  };

  sendOTPMessage(body)
    .then((resp) => {
      console.log("📩 Backend Response:", resp.data);

      if (!resp.data) {
        errorTost("No response received.");
        return;
      }

      const encryptedBase64 = resp.data.otp;

      if (!encryptedBase64) {
        errorTost("OTP missing in response.");
        return;
      }

      console.log("📦 Received Encrypted OTP (Base64):", encryptedBase64);

      try {
        // 1️⃣ BASE64 → Ciphertext
        const encryptedCipher = atob(encryptedBase64);
        console.log("🔒 AES Ciphertext:", encryptedCipher);

        // 2️⃣ AES Decrypt
        const bytes = CryptoJS.AES.decrypt(encryptedCipher, "hts secret key");
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
          console.error("❌ AES Decryption failed.");
          errorTost("Failed to decrypt OTP.");
          return;
        }

        console.log("🔓 Decrypted OTP:", decryptedText);

        const finalOTP = parseInt(decryptedText);

        if (isNaN(finalOTP)) {
          console.error("❌ Decrypted OTP is NaN:", decryptedText);
          errorTost("Invalid OTP received.");
          return;
        }

        // 3️⃣ Save OTP in state
        setRecievedOtp(finalOTP);
        console.log("✅ Final OTP Saved:", finalOTP);

        // 4️⃣ Start OTP timeout countdown (15 min)
        setTimeout(smsTimeOut, 900000);
      } catch (error) {
        console.error("❌ OTP Decryption Error:", error);
        errorTost("OTP decryption failed.");
      }
    })
    .catch((err) => {
      console.error("❌ API Error:", err);
      if (err?.message) errorTost(err.message);
      else errorTost("Something went wrong.");
    });
}




  function smsTimeOut() {
    if (verifiedPhoneNumber.current === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      verifiedPhoneNumber.current = false;
      setShowOtp(true);
      setResendButton(true);
      setOtpTimer(true);
      // setShowEmailOtp(false);
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      setRecievedOtp(null);
    }
  }
  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      // setVerifiedPhoneNumber(true);
      verifiedPhoneNumber.current = true;
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  // -------------------------------------------------------------------
  function updateEmailOrPhoneNumber() {
    // ??First Condition any error is there for phoneNumber and email
    if (helperText.email === '' && helperText.isPhoneNumber === '') {
      // ??check for verified email and phoneNumber
      if (helperText.onChangePhoneNumber && helperText.onChangeEmail) {
        if (verifiedEmail.current && verifiedPhoneNumber.current) {
          let obj = {
            contactNumber: updateProfile.contactNumber,
            email: updateProfile.email
          }
          console.log({ obj })
          updateLead(obj);
        }
        else if (!verifiedEmail.current && !verifiedPhoneNumber.current) {
          errorTost('Please verify email and phone number')
        }
      } else if (helperText.onChangePhoneNumber) {
        if (verifiedPhoneNumber.current) {
          let obj = {
            contactNumber: updateProfile.contactNumber,
          }
          console.log({ obj })
          updateLead(obj);
        } else {
          errorTost('Please verify email.');
        }
      } else if (helperText.onChangeEmail) {
        if (verifiedEmail.current) {
          let obj = {
            email: updateProfile.email
          }
          console.log({ obj })
          updateLead(obj);
        } else {
          errorTost('Please verify phone number.');
        }

      }
    }
  }
  function updateLead(obj) {
    updateLeadPersonTable(data?.personid, obj).then((response) => {
      console.log({ response });
      let body = {
        name: data?.leadname,
        contactNumber: `+${response[0]?.contactNumber}`,
        email: response[0]?.email,
        leadId: data?.leadId,
      };
      data.leadcontactnumber = response[0]?.contactNumber;
      data.leademail = response[0]?.email;
      console.log('body passed to create virtual acc api', { body })
      let payload = {
        number: `+${response[0]?.contactNumber}`,
        // ! do not update email as email is of CUID
        // email: response[0]?.email,
      }
      updateLeadLoginTable(data?.leaddisplayid, payload).then(res => {
        createVirtualAccountFun(body);
      }).catch(e => {
        errorTost(e.message)
      })

    }).catch((err) => {
      console.log('error While updating', { err });
      errorTost(err.message);
    });
  }
  function createVirtualAccountFun(body) {

    presentLoader();
    createVirtualAccount(body)
      .then((resp) => {
        console.log("create Virtual account resp", resp);
        if (resp?.data?.success) {
          dismissLoader();
          closeModal();
          returnRes(true);
          successTost("Virtual account created successfully");
        } else {
          dismissLoader();
          if (resp?.data?.errorMsg.includes('Virtual Account already Exists')) {
            // ??open modal 
            errorTost('Please make unique combination of email and phone number please.');
            setHelperText((pre) => {
              pre.onChangeEmail = false;
              pre.onChangePhoneNumber = false;
              return { ...pre }
            });

            verifiedEmail.current = false;
            verifiedPhoneNumber.current = false;
          } else {
            dismissLoader();
            errorTost(resp?.data?.errorMsg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dismissLoader();
        errorTost(err.message);
      });
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Create Virtual Account</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          {/* <div className={cssClasses.wrapperStepper}>
          <MobileStepper
            variant="progress"
            className={classes.stepper}
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
            sx={{
              maxWidth: "100%",
              // maxWidth:600,
              flexGrow: 1,
              margin: "0 auto",
              background: "#F5F5F5 !important",
            }}
          />
        </div> */}
          {activeStep === 1 && (
            <div className={cssClasses.content}>
              <div className={cssClasses.title} style={{ marginTop: '2rem', lineHeight: '3rem', color: '#667085' }}>Virtual account with <span style={{ color: '#344054' }}>{data?.leademail} </span>and <span style={{ color: '#344054' }}>+{data?.leadcontactnumber}</span> already exists</div>
              <div className={cssClasses.title} style={{ color: '#344054' }}>Do you want to update email and phone number ?</div>
            </div>
          )}
          {activeStep === 2 && (
            <div className={cssClasses.content}>
              <div style={{
                textAlign: 'left',
              }}>
                <CustomInput
                  value={updateProfile?.email}
                  label={"Email"}
                  // mandatory={true}
                  inputType={"label"}
                  position={"end"}
                  greenTick={verifiedEmail.current === true}
                  labelText={emailLabelText}
                  disabled={showEmailOtp || verifiedEmail.current === true || helperText.disableEmail}
                  clicked={(e) => {
                    console.log(e);
                    if (e === 'Send Otp') {
                      sendOtpToVerifyEmail(e);
                    } else if (e === 'Resend Otp') {
                      sendOtpToVerifyEmail(e);
                    }
                  }}
                  handleChange={(newValue) => {
                    setEmailLabelText('');
                    newValue = newValue.trimStart();
                    const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!newValue.trim()) {
                      setEmailLabelText('');
                      helperText.email = "Please Enter Email Id";
                    } else if (!newValue.match(emailIDCond)) {
                      setEmailLabelText('');
                      helperText.email = "Please Enter Email in Proper Format";
                    } else {
                      setIsLoadingEmail(true);
                      setEmailLabelText('');
                      helperText.email = "verifying...";
                      if (newValue !== '') {
                        checkEmailExists(newValue);
                      } else if (newValue === '') {
                        console.log('hii')
                        setEmailLabelText('');
                      }
                    }
                    if (newValue.length <= 100) {
                      setUpdateProfile((pre) => {
                        pre.email = newValue;
                        return { ...pre };
                      });
                    }
                  }}
                  placeholder="Enter contact person Email"
                  helperText={helperText.email}
                // isLoading={isLoadingEmail}
                />
                {otptimerEmail && (

                  <div className={cssClasses.resendOtp}>
                    {" "}
                    Resend Otp in{" "}
                    <CountdownTimer startFrom={180} onComplete={() => { setEmailLabelText('Resend Otp'); setOtpTimerEmail(false); }}
                      timeFormatter={(time) => {
                        return (<span>{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                      }}
                    />
                  </div>
                )}
                {showEmailOtp && (
                  <div className={cssClasses.otpContainer}>
                    <input
                      className={cssClasses.otpInput}
                      name="otp1"
                      type="text"
                      autoComplete="off"
                      value={emailState.otp1}
                      // onKeyPress={keyPressed}
                      onChange={(e) => optEmailChange("otp1", e)}
                      tabIndex="1"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-0'
                    />
                    <input
                      name="otp2"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp2}
                      onChange={(e) => optEmailChange("otp2", e)}
                      tabIndex="2"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-1'
                    />
                    <input
                      name="otp3"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp3}
                      onChange={(e) => optEmailChange("otp3", e)}
                      tabIndex="3"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-2'
                    />
                    <input
                      name="otp4"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp4}
                      onChange={(e) => optEmailChange("otp4", e)}
                      tabIndex="4"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-3'
                    />

                    <div>
                      <Button
                        tabIndex={5}
                        style={{
                          color: "#ffffff",
                          backgroundColor: "#155EEF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                        }}
                        btnName={"Submit OTP"}
                        clicked={submitEmailOtp}
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* {verifiedEmail.current&&(
                <div>
                    <Button
                        tabIndex={5}
                        style={{
                        color: "#ffffff",
                        backgroundColor: "#155EEF",
                        fontSize: "1.4rem",
                        lineHeight: "2rem",
                        }}
                        btnName={"Update"}
                        clicked={()=>{
                        // Update Query Remaining
                        let obj={
                            email:updateProfile.email
                        }
                        updateLeadPersonTable(loggedInUser?.personId?.personId,obj).then((response)=>{
                            console.log({response});
                            successTost('Email updated successfully');
                            obj={
                            ...loggedInUser.personId,
                            email: updateProfile.email
                            }
                        
                        }).catch((err)=>{
                            console.log(err);
                        });
                        setHelperText((pre)=>{
                            pre.disableEmail=true;
                            return {...pre}
                        });
                        // setVerifiedEmail(false);
                        verifiedEmail.current=false;
                        }}
                    />
                </div>
            )} */}

              {/* Phone Number Block */}
              <div style={{
                textAlign: 'left',
                width: '100%'
              }}>
                <div style={{ position: 'relative' }}>
                  <div className={cssClasses.blockLabel} >
                    Phone Number
                    {/* <span style={{ color: "red" }}> *</span> */}
                  </div>
                  <PhoneInput
                    defaultCountry="IN"
                    value={data?.leadcontactnumber.toString().length === 10 ? "+91" + data?.leadcontactnumber : '+' + data?.leadcontactnumber}
                    disabled={showOtp || verifiedPhoneNumber.current || resendButton || helperText.disableContactNumber}
                    placeholder="Enter phone number"
                    onChange={(phone) => {
                      console.log({ phone });
                      setUpdateProfile((pre) => {
                        pre.contactNumber = phone === undefined ? '+91' : phone;
                        return { ...pre };
                      });


                      if (phone !== undefined) {
                        console.log(phone.length);
                        console.log(isValidPhoneNumber(phone));
                        // setVerifiedPhoneNumber(false);
                        verifiedPhoneNumber.current = false;
                        if (phone.length >= 1) {
                          if (isValidPhoneNumber(phone) === false) {
                            verifiedPhoneNumber.current = false;
                            helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                            setShowOtp(false);
                          } else {
                            helperText.isPhoneNumber = "verifying...";
                            if (phone?.substring(0, 3) === "+91") {
                              setIsInterNational(false);
                            } else {
                              setIsInterNational(true);
                            }
                            if ('+' + data?.leadcontactnumber.toString() === updateProfile.contactNumber.toString()) {
                              setHelperText((pre) => {
                                pre.onChangePhoneNumber = false;
                                pre.isPhoneNumber = '';
                                return { ...pre }
                              });
                            } else {
                              IsNumberBlackListed(phone);
                              setHelperText((pre) => {
                                pre.onChangePhoneNumber = true;
                                return { ...pre }
                              });
                            }

                          }

                        }
                      } else {
                        helperText.isPhoneNumber = "Please Enter  Phone Number";
                        setShowOtp(false);

                      }
                    }}
                  />
                  <p
                    style={{ color: "red", fontSize: "1.4rem", lineHeight: "1.66" }}
                  >
                    {helperText.isPhoneNumber}
                  </p>
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber.current === false &&
                    otptimer === false &&
                    showOtp === false &&
                    updateProfile.contactNumber !== "" &&
                    !helperText.disableContactNumber &&
                    helperText.onChangePhoneNumber && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          smsApiCall();
                        }}
                      >
                        Verify Otp
                      </div>
                    )}

                  {verifiedPhoneNumber.current === false &&
                    showOtp === true &&
                    resendButton === true && (
                      <div
                        className={cssClasses.verifyOtp}
                        onClick={() => {
                          setHelperText((pre) => {
                            pre.isPhoneNumber = "";
                            return { ...pre };
                          });
                          if (resendButton) {
                            smsApiCall();
                            // successTost("Otp has been sent");
                          } else {

                            console.log("Please wait for 3 min");
                          }
                        }}
                      >
                        Resend Otp
                      </div>
                    )}
                  {verifiedPhoneNumber.current === false &&
                    showOtp === true &&
                    resendButton === false && (
                      <div className={cssClasses.resendOtp}>
                        {" "}
                        Resend Otp in{" "}
                        {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
                        <CountdownTimer startFrom={180} onComplete={() => { setResendButton(true) }}
                          timeFormatter={(time) => {
                            return (<span>{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                          }}
                        />
                      </div>
                    )}
                  {helperText.isPhoneNumber === "" &&
                    verifiedPhoneNumber.current &&
                    otptimer === false && (
                      <div className={cssClasses.verifyOtp}>
                        <CheckCircleSharpIcon
                          style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                          color={"success"}
                        />
                      </div>
                    )}
                  {showOtp && (
                    <div className={cssClasses.otpContainer}>
                      <input
                        className={cssClasses.otpInput}
                        name="otp1"
                        type="text"
                        autoComplete="off"
                        value={state.otp1}
                        // onKeyPress={keyPressed}
                        onChange={(e) => optChange("otp1", e)}
                        tabIndex="1"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id='opt-0'
                      />
                      <input
                        name="otp2"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp2}
                        onChange={(e) => optChange("otp2", e)}
                        tabIndex="2"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id='opt-1'
                      />
                      <input
                        name="otp3"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp3}
                        onChange={(e) => optChange("otp3", e)}
                        tabIndex="3"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id='opt-2'
                      />
                      <input
                        name="otp4"
                        type="text"
                        autoComplete="off"
                        className={cssClasses.otpInput}
                        value={state.otp4}
                        onChange={(e) => optChange("otp4", e)}
                        tabIndex="4"
                        maxLength="1"
                        onKeyUp={(e) => inputfocus(e)}
                        id='opt-3'
                      />

                      <div>
                        <Button
                          tabIndex={5}
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#155EEF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          btnName={"Submit OTP"}
                          clicked={submitOtp}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>)}
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={activeStep === 1 ? "Cancel" : "Back"}
              clicked={() => {
                if (activeStep === 1) {
                  closeModal();
                } else {
                  handleBack();
                }
              }}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              disable={activeStep === 2 ? (helperText?.onChangeEmail && !verifiedEmail.current) || (helperText?.onChangePhoneNumber && !verifiedPhoneNumber.current) || (!helperText.onChangeEmail && !helperText?.onChangePhoneNumber) : false}
              btnName={activeStep === 1 ? "Yes" : "Update and Create"}
              clicked={() => {
                // save();
                if (activeStep === 1) {
                  handleNext();
                } else if (activeStep === 2) {
                  updateEmailOrPhoneNumber();
                }
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
